import axios from 'axios';
import { encryptString } from '../utils/cryptoUtils.js';

// 순환 참조 방지를 위해 직접 axios 인스턴스 생성
const authClient = axios.create({
  baseURL: process.env.REACT_APP_API_HOST || 'http://localhost:8080',
  timeout: 30000,
  withCredentials: true, // 쿠키 포함
});

// 인증 API
export const authApi = {
  // 로그인 초기화 (공개키 받기)
  initLogin: async () => {
    const response = await authClient.post('/api/auth/initLogin', null, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  },

  // RSA 암호화된 로그인 (FormData로 전송)
  login: async ({ username, password }) => {
    // FormData 생성
    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);
    
    const response = await authClient.post('/api/auth/login', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    
    return response.data;
  },

  // 로그아웃
  logout: async () => {
    const response = await authClient.post('/api/auth/logout', null, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  },

  // 토큰 갱신
  refresh: async () => {
    const response = await authClient.post('/api/auth/refresh', null, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  },
};